<h2>Patient Demographics</h2>
<mat-card *ngIf="patientPayload" apperance="outlined">
  <mat-card-header>
    <mat-card-title>Patient Demographics</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p><strong>Birthdate:</strong> {{ patientPayload.birthDate | date: 'MM/dd/yyyy' }}</p>
    <p><strong>Gender:</strong> {{ patientPayload.gender }}</p>
  </mat-card-content>
</mat-card>